module.exports = __webpack_public_path__ + "img/graph-blue.778ece76.webp";